<template>
  <div>
    <div class="video-frame open" v-if="isShown">
      <div class="video-box">
        <a
          href="javascript:"
          class="video-close btn-close-video"
          aria-label="Close"
          @click="isShown = false"
        >
          &times;
        </a>

        <div class="video-player">
          <div class="welcome-text">
            <h5>
              Welcome to the Star Product Program – ScanCom’s tool that allows
              you to become the designer.
            </h5>
            <p>
              Here, you will find a select collection of pieces, ranging from
              dining to lounging, complete with a <b>3D Configurator</b> where
              you can select and change anything from fabric to frame colours,
              various table tops, armrests and more... The only limitation is
              almost your imagination!
            </p>
            <p>
              On the frontpage here, you will find some general information
              that’s good to know as well as an FAQ, and in the Collection
              Overview you will be able to create your own collections and
              download presentations and offersheets; all with very few clicks
              of your mouse.
            </p>
            <p><b>Enjoy a new level of creativity, powered by ScanCom!</b></p>
            <br />
          </div>
          <video id="intro-video" controls muted autoplay>
            <source
              src="https://spp.scancom.net/video/screen-capture.webm"
              type="video/webm"
            />
            Your browser does not support HTML video.
          </video>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["openVideo"],
  data() {
    return {
      isShown: true,
    };
  },
  watch: {
    openVideo(val) {
      this.isShown = val;
    },
    isShown(val) {
      this.$emit("update:openVideo", val);
    },
  },
};
</script>

<style scoped>
.video-frame {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: #e2e2e2b8;
  display: none;
  z-index: 1041;
}
.video-frame.open {
  display: block;
}
.video-frame .video-box {
  position: absolute;
  left: 50%;
  text-align: center;
}
.video-frame .video-box .video-player video {
  max-width: 100%;
  height: 100%;
}
.video-frame .video-box .video-player {
  width: calc(100vw - 4rem);
  z-index: 2;
  position: relative;
  bottom: 3rem;
  left: -50%;
  background-color: #fff;
  padding: 3rem;
  max-height: calc(100vh - 4rem);
  overflow: auto;
}
h5 {
  color: black;
  font-weight: 600 !important;
}
.btn-close-video {
  position: relative;
  -webkit-box-sizing: content-box;
  box-sizing: content-box;
  width: 2rem;
  height: 1rem;
  padding: 0em 0.25em;
  color: #ffffff;
  border: 0;
  border-radius: 0.25rem;
  opacity: 1.5;
  font-size: 3rem;
  left: 1rem;
}
@media screen and (max-width: 600px) {
  .btn-close-video {
    position: relative;
    -webkit-box-sizing: content-box;
    box-sizing: content-box;
    width: 2rem;
    height: 1rem;
    padding: 2rem 3rem 0rem 0rem;
    color: #ffffff;
    border: 0;
    border-radius: 0.25rem;
    opacity: 1.5;
    font-size: 3rem;
    left: 1rem;
  }
  .video-frame .video-box .video-player {
    width: calc(100vw - 4rem);
    z-index: 2;
    position: relative;
    bottom: 1rem;
    left: -50%;
    background-color: #fff;
    padding: 1rem;
    max-height: calc(100vh - 4rem);
    overflow: auto;
    margin: 0rem 1rem 0rem 0rem;
  }
  .video-frame .video-box .video-player video {
    max-width: 100%;
  }
}
@media screen and (min-width: 640px) {
  .video-frame .video-box .video-player {
    width: calc(60vw);
  }
}
</style>